import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServiceDetailsPage() {
  pageTitle('Telegram Bots & Apps');
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <PageHeading
        title='Telegram Bots & Apps'
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={'Telegram Bots & Apps'}
      />

      <Spacing lg='120' md='60' />

      {/* Telegram Bot Introduction */}
      <Div className="container">
        <SectionHeading
          title='What Is a Telegram Bot?'
          subtitle='Powering Automation on Telegram'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <p className='cs-text_large text-center'>
          Telegram bots are automated software programs that perform various tasks on the Telegram messaging platform. These bots can interact with users, process commands, provide information, and streamline business processes, making Telegram a powerful tool for customer engagement, automation, and productivity.
        </p>
        <Spacing lg='20' md='15' />
        <p className='cs-text_large text-center'>
          At Dappster Studio, we offer custom Telegram bot development services to help businesses and individuals harness the power of automation and communication.
        </p>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Telegram Bot Services */}
      <Div className="container">
        <SectionHeading
          title='Our Telegram Bot Development Services'
          subtitle='Automate, Engage, and Scale'
          variant='cs-style1 text-center'
        />
        <Spacing lg='90' md='45' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/service_icon_1.svg' title='Custom Bot Development' subtitle='Tailored bots with functionalities that align with your business needs.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/service_icon_2.svg' title='Chat Automation' subtitle='Automate customer interactions, FAQs, and support.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/service_icon_3.svg' title='E-commerce Integration' subtitle='Enable transactions, product catalogs, and order management via Telegram.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/service_icon_4.svg' title='Notification and Alert Bots' subtitle='Real-time updates for businesses, such as stock alerts, news, or reminders.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/service_icon_5.svg' title='Data Collection and Surveys' subtitle='Gather feedback, conduct polls, or manage customer data effortlessly.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/service_icon_6.svg' title='Crypto & Blockchain Bots' subtitle='Wallet integrations, cryptocurrency tracking, and transaction notifications.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-6">
            <IconBox icon='/images/icons/service_icon_7.svg' title='Gaming Bots' subtitle='Interactive bots for gaming, quizzes, or trivia.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-6">
            <IconBox icon='/images/icons/api-icon.svg' title='API Integration' subtitle='Seamless integration with your existing systems or third-party APIs.' />
            <Spacing lg='30' md='30' />
          </Div>
        </Div>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Telegram Bot Industries */}
      <Div className="container">
        <SectionHeading
          title='Industries We Serve'
          subtitle='Use Cases for Telegram Bots'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/cart-icon.svg' title='E-commerce' subtitle='Simplify customer interactions and transactions.' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/education-icon.svg' title='Education' subtitle='Provide resources, manage student queries, and deliver updates.' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/healthcare-icon.svg' title='Healthcare' subtitle='Appointment scheduling, reminders, and health tips.' />
          </Div>
        </Div>
        <Div className="row mt-lg-5 " >
          <Div className="col-lg-6">
            <IconBox icon='/images/icons/money-icon.svg' title='Finance' subtitle='Automated notifications for transactions, stock updates, and account balances.' />
          </Div>
          <Div className="col-lg-6">
            <IconBox icon='/images/icons/game-icon.svg' title='Gaming & Entertainment' subtitle='Create engaging user experiences with interactive bots.' />
          </Div>
        </Div>
      </Div>

      <Spacing lg='150' md='80' />
    </>
  )
}
